<template>
  <b-container fluid class="full-page">
    <div class="full-page-wrapper">
      <b-row sm="3" align-h="center">
        <MdChatbubblesIcon w="100px" h="100px"/>
      </b-row>
      <b-row align-h="center" >
        <b-col sm="3">
          <b-form @submit="register">
            <b-form-group
                id="input-group-1"
                label="First Name:"
                label-for="input-1">
                <b-form-input
                id="input-1"
                v-model="user.name"
                type="text"
                placeholder="Enter first name"
                required
                />
            </b-form-group>
            <b-form-group
                id="input-group-4"
                label="Last Name:"
                label-for="input-4">
                <b-form-input
                id="input-1"
                v-model="user.lastname"
                type="text"
                placeholder="Enter last name"
                required
                />
            </b-form-group>
            <b-form-group
                id="input-group-2"
                label="Email address:"
                label-for="input-2">
                <b-form-input
                id="input-2"
                v-model="user.email"
                type="email"
                placeholder="Enter email"
                trim
                required
                />
            </b-form-group>
            <b-form-group
                id="input-group-3"
                label="Password:"
                label-for="input-3">
                <b-form-input
                id="input-3"
                v-model="user.password"
                type="text"
                placeholder="Enter Password"
                required
                />
            </b-form-group>
            <p class="error" v-if="error">{{ error }}</p>
            <p class="success" v-if="success">{{ success }}</p>
            <b-form-group>
              <b-button type="submit" class="btn-block main-btn">Create account</b-button>
            </b-form-group>
            <router-link class="btn btn-secondary btn-block" to="/login">Log In</router-link>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import MdChatbubblesIcon from 'vue-ionicons/dist/md-chatbubbles.vue'

export default {
  name: 'Register',
  components: {
    MdChatbubblesIcon
  },
  data () {
    return {
      error: false,
      success: false,
      user: {
        name: '',
        lastname: '',
        email: '',
        password: ''
      }
    }
  },
  methods: {
    async register (event) {
      event.preventDefault()

      try {
        const res = await this.axios.post('/auth/register', { user: this.user })
        if (!res.data.success) {
          this.success = false
          this.error = res.data.message
          return
        }

        this.error = false
        this.success = 'Account created successfully. Please contact your system administrator to activate the account.'

        this.user.name = ''
        this.user.lastname = ''
        this.user.email = ''
        this.user.password = ''
      } catch (err) {
        this.success = false
        this.error = 'Something went wrong. Please try again :('
        console.log(err)
      }
    }
  }
}
</script>

<style scoped>
.full-page{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.full-page-wrapper {
  flex: 1;
}
</style>
